<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/event_production/DSC4540.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Event Production" h1="Back of House" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <Feature inPageBottom label="complete backstage<br/>compound" description="with ample space for multi-headliner<br/>tour featuring over 30,000 square feet<br/>of space for tour production team" icon="event_production/icon_map.svg" />
                        <Feature inPageBottom label="additional<br/>corridor" description="for secure artist<br/>movement" icon="event_production/icon_artist-walking.svg" />
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
//TODO
import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Feature from "@/patterns/Feature.vue";
export default {
  name: "BackOfHouse",
  components: { PageBottom, TitleContent, Feature },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.image img {
  object-position: center;
}
</style>